import { call, put, takeEvery } from 'redux-saga/effects';
import { APP, LOCALSESSIONDATAKEYS, WEB, _BROTHER_PLUS_API_ENDPOINTS, SUCCESS, FAILURE } from '../../../constants/AppConstants';
import { _CALLGETAPI } from '../../../api/apiHandler';
import { consentKeyMap } from '../../../utils/consentService';
import i18next from 'i18next';
import {
    getUserNotificationConsentDetailsRequest,
    getUserNotificationConsentDetailsSuccess,
    getUserNotificationConsentDetailsFailure
} from './GetUserNotificationConsentDetailsSlice.js';
import { getLocalSessionData } from '../../../utils/Authentication/handleUserSession.js';

function _GETUSERNOTIFICATIONCONSENTDETAILS(userId) {
    const endpoint = _BROTHER_PLUS_API_ENDPOINTS.GET_USER_NOTIFICATION_CONSENT_DETAILS;
    const payload = {
        params: {
            userId: userId
        }
    };

    return _CALLGETAPI(endpoint, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            throw error;
        });
}

function* getUserNotificationConsentDetailsSaga() {
    try {
        const userId = getLocalSessionData(LOCALSESSIONDATAKEYS.UID);
        const userNotificationConsentDetails = yield call(_GETUSERNOTIFICATIONCONSENTDETAILS, userId);
        const actionStatus = userNotificationConsentDetails?.actionStatus?.toUpperCase();
        const isSuccess = actionStatus === SUCCESS;
        const isNewUser = actionStatus === FAILURE
            && userNotificationConsentDetails?.[consentKeyMap[WEB]] === null
            && userNotificationConsentDetails?.[consentKeyMap[APP]] === null;
        if (isSuccess || isNewUser) {
            yield put(getUserNotificationConsentDetailsSuccess(userNotificationConsentDetails));
        } else {
            yield put(getUserNotificationConsentDetailsFailure(i18next.t('ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR')));
        }
    } catch (error) {
        yield put(getUserNotificationConsentDetailsFailure(error.message));
    }
}

export default function* watchGetUserNotificationConsentDetailsService() {
    yield takeEvery(getUserNotificationConsentDetailsRequest.type, getUserNotificationConsentDetailsSaga);
}
